// src/auth/studentProfileAccess.js
//
// Cine poate deschide profilul elevului din calendare si ce vede acolo.
//
// Personalul administrativ are acces complet. Orice instructor cu fisa
// rezolvata poate deschide profilul, dar numai in citire (vezi
// `isInstructorSelfProfileMode`) si -- cu exceptia instructorului SUPERIOR --
// fara numele altor instructori: lectiile facute cu altii, inlocuirile si
// instructorul preferat se afiseaza mascat. Un instructor isi vede doar
// propriul nume, inclusiv cand el e inlocuitorul zilei.
//
// Predicatele stau intr-un singur loc pentru ca meniul de actiuni, dublu-clicul
// si long-press-ul sa nu poata ajunge la concluzii diferite.

import { normalizeRole, ROLES } from "./access";
import {
   isSuperiorInstructorType,
   resolveInstructorTypeFromRecord,
} from "../constants/instructors";

export function canInstructorOpenStudentProfile(instructor) {
   return Boolean(instructor) && typeof instructor === "object";
}

/**
 * `instructor` e fisa de instructor a contului logat (null pentru celelalte
 * roluri). Personalul administrativ pastreaza accesul complet.
 */
export function canOpenStudentProfile(user, instructor) {
   if (normalizeRole(user?.role) !== ROLES.INSTRUCTOR) return true;
   return canInstructorOpenStudentProfile(instructor);
}

/**
 * Instructorii (in afara de SUPERIOR) nu vad cu ce alti instructori a lucrat
 * elevul. Cat timp fisa instructorului nu e rezolvata, mascam (fail closed).
 */
export function shouldMaskOtherInstructorsInStudentProfile(user, instructor) {
   if (normalizeRole(user?.role) !== ROLES.INSTRUCTOR) return false;
   if (!instructor) return true;
   return !isSuperiorInstructorType(resolveInstructorTypeFromRecord(instructor));
}

function normalizeId(value) {
   return value == null ? "" : String(value).trim();
}

/**
 * `person` e un instructor afisat (fisa de instructor sau obiectul `instructor`
 * de pe rezervare). E „al meu" daca are id-ul fisei mele sau userId-ul contului
 * meu.
 */
export function isViewerInstructorPerson(person, { instructor, user } = {}) {
   if (!person || typeof person !== "object") return false;

   const viewerInstructorId = normalizeId(instructor?.id);
   const personId = normalizeId(person?.id);
   if (viewerInstructorId && personId && personId === viewerInstructorId) {
      return true;
   }

   const viewerUserId = normalizeId(user?.id ?? instructor?.userId);
   const personUserId = normalizeId(person?.userId ?? person?.user_id);
   return Boolean(viewerUserId) && personUserId === viewerUserId;
}
